// requires lesson ID to use this modal

import { createConfirmation } from 'react-confirm'
import ModalProvider from "./ModalProvider";

const modal = createConfirmation(ModalProvider);

export default function (opts = {}) {
  if (!opts.lessonId) {
    throw new Error('opts.lessonId is missing.');
  }
  
  if (!opts.classDetail) {
    opts.needToLoadClassDetail = true;
  }

  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/Attendance/index.js